module.exports = __webpack_public_path__ + "img/logo-rossignol.bd482811.svg";